import { render, staticRenderFns } from "./placeholder-card.component.vue?vue&type=template&id=6e3c503b&scoped=true"
import script from "./placeholder-card.component.vue?vue&type=script&lang=js"
export * from "./placeholder-card.component.vue?vue&type=script&lang=js"
import style0 from "./placeholder-card.component.vue?vue&type=style&index=0&id=6e3c503b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c503b",
  null
  
)

export default component.exports